<form [formGroup]="form" class="h-full w-full overflow-x-hidden overflow-y-auto flex flex-col items-stretch justify-start space-y-4">
    <app-autocomplete
      class="w-full block"
      label="¿Cómo se llama la empresa para la que trabajas?"
      [items]="companies"
      labelKey="label"
      valueKey="value"
      [defaultValue]="defaultData?.company"
      (valueChange)="setCompany($event)">
    </app-autocomplete>
    @for (item of dataInputs(); track $index) {
        <app-input class="w-full"
            [config]="item"
            [timeoutSeconds]="0.6"
            (submitValue)="handleValue($event)">
        </app-input>
    }

    <app-selected class="w-full"
        [config]="dataSelected().at(0)"
        (selectValue)="handleValue($event)"
    ></app-selected>

    <app-autocomplete
      label="¿Cuál es tu profesión?"
      [items]="codpros"
      labelKey="label"
      valueKey="value"
      [defaultValue]="defaultData?.codpro"
      (valueChange)="form.patchValue({ codpro: $event })">
    </app-autocomplete>

    <app-selected class="w-full"
        [config]="dataSelected().at(1)"
        (selectValue)="handleValue($event)"
    ></app-selected>

    <!-- {{ form.value | json }} -->
</form>
